<template>
	<page enable-flex style="background: #fff;">
		<scan ref="scan" :disabled="!!code" @scan="codeHandle">
			<div class="head">
				<h5>{{productName || '-'}}</h5>
				<p>背贴码：{{codeInfo.produce_unique_code || '-'}}</p>
			</div>
			
			<dl class="assets">
				<dt class="flex-center">轮播图</dt>
				<dd>
					<p class="tip">商品轮播图片，有配件时需传配件图，合计13张。<br>发布到暗拍渠道（小黑暗拍 / 采货侠暗拍 / 鱼市暗拍）时可以只拍8~12张</p>
					<c-drag-sort v-model="bannerList" class="list flex-wrap">
						<template #prepend>
							<div key="peijin" @click="$preview({src: peijianImage})">
								<div v-if="peijianImage" class="image flex-center">
									<img :src="peijianImage" alt="">
									<a @click.stop="peijianImage = ''"><i class="tf">&#xe60f;</i></a>
									<div class="image-tag flex-center">配件</div>
								</div>
								<div v-else class="upload flex-column flex-center" @click="uploadHandle(false, 'peijianImage', 1)">
									<i class="tf">&#xe727;</i>
									<span>配件图</span>
								</div>
							</div>
						</template>

						<template #default="{item, id, index}">
							<c-drag-item :key="id" class="image flex-center" @click.native="$preview({src: bannerList, index})">
								<img :src="item" alt="">
								<a @click.stop="bannerList.splice(index, 1)"><i class="tf">&#xe60f;</i></a>
							</c-drag-item>
						</template>

						<template #append>
							<div v-if="(peijianImage ? 1 : 0) + bannerList.length < 13" class="upload flex-center" @click="uploadHandle(true, 'bannerList', 13 - bannerList.length - (peijianImage ? 1 : 0))"><i class="tf">&#xe727;</i></div>
						</template>
					</c-drag-sort>
				</dd>
			</dl>
			<dl class="assets">
				<dt class="flex-center">B端靓机轮播图</dt>
				<dd>
					<p class="tip">上架小黑靓机 / 采货侠靓机 / 鱼市靓机必传，需3张</p>
					<c-drag-sort v-model="liangjiList" class="list flex-wrap">
						<template #default="{item, id, index}">
							<c-drag-item :key="id" class="image flex-center" @click="$preview({src: liangjiList, index})">
								<img :src="item" alt="">
								<a @click.stop="liangjiList.splice(index, 1)"><i class="tf">&#xe60f;</i></a>
							</c-drag-item>
						</template>

						<template #append>
							<div v-if="liangjiList.length < 3" class="upload flex-center" @click="uploadHandle(true, 'liangjiList', 3 - liangjiList.length)"><i class="tf">&#xe727;</i></div>
						</template>
					</c-drag-sort>
				</dd>
			</dl>
			<dl class="assets">
				<dt class="flex-center">闲鱼严选渠道轮播图</dt>
				<dd>
					<p class="tip">上架闲鱼严选渠道必传，需2张</p>
					<c-drag-sort v-model="xianyuList" class="list flex-wrap">
						<template #default="{item, id, index}">
							<c-drag-item :key="id" class="image flex-center" @click="$preview({src: xianyuList, index})">
								<img :src="item" alt="">
								<a @click.stop="xianyuList.splice(index, 1)"><i class="tf">&#xe60f;</i></a>
							</c-drag-item>
						</template>

						<template #append>
							<div v-if="xianyuList.length < 2" class="upload flex-center" @click="uploadHandle(true, 'xianyuList', 2 - xianyuList.length)"><i class="tf">&#xe727;</i></div>
						</template>
					</c-drag-sort>
				</dd>
			</dl>
			<dl class="assets">
				<dt class="flex-center">京东首图</dt>
				<dd>
					<p class="tip">上架京东渠道必传，需1张</p>
					<c-drag-sort v-model="jingdongList" class="list flex-wrap">
						<template #default="{item, id, index}">
							<c-drag-item :key="id" class="image flex-center" @click="$preview({src: jingdongList, index})">
								<img :src="item" alt="">
								<a @click.stop="jingdongList.splice(index, 1)"><i class="tf">&#xe60f;</i></a>
							</c-drag-item>
						</template>

						<template #append>
							<div v-if="jingdongList.length < 1" class="upload flex-center" @click="uploadHandle(true, 'jingdongList', 1)"><i class="tf">&#xe727;</i></div>
						</template>
					</c-drag-sort>
				</dd>
			</dl>
			<dl v-if="flawListOfB.length" class="assets">
				<dt class="flex-center">B端质检瑕疵图</dt>
				<dd class="flex-wrap">
					<div v-for="(item, i) in flawListOfB" :key="i" @click="$preview({src: item.image_url})">
						<div v-if="item.image_url" class="image flex-center">
							<img :src="item.image_url" alt="">
							<a @click.stop="item.image_url = ''"><i class="tf">&#xe60f;</i></a>
							<div class="image-edit flex-center" @click.stop="flawHandle(item)"><i class="tf-edit"></i></div>
						</div>
						<div v-else class="upload flex-center" @click="flawHandle(item)"><i class="tf">&#xe727;</i></div>
						<p class="image-text">{{item.release_name}}</p>
					</div>
				</dd>
			</dl>
			<dl v-if="flawListOfC.length" class="assets">
				<dt class="flex-center">C端质检瑕疵图</dt>
				<dd class="flex-wrap">
					<div v-for="(item, i) in flawListOfC" :key="i" @click="$preview({src: item.image_url})">
						<div v-if="item.image_url" class="image flex-center">
							<img :src="item.image_url" alt="">
							<a @click.stop="item.image_url = ''"><i class="tf">&#xe60f;</i></a>
							<div class="image-edit flex-center" @click.stop="flawHandle(item)"><i class="tf-edit"></i></div>
						</div>
						<div v-else class="upload flex-center" @click="flawHandle(item)"><i class="tf">&#xe727;</i></div>
						<p class="image-text">{{item.release_name}}</p>
					</div>
				</dd>
			</dl>
		</scan>

		<template v-if="codeInfo.produce_unique_code" #button>
			<c-button color="main" hollow size="form" @click="mp.navigateBack()">取消</c-button>
			<c-button class="foot-button" size="form" color="main" @click="submitHandle">确认提交</c-button>
		</template>
	</page>
</template>

<script>
	export default {
		props: {
			code: String
		},

		data() {
			return {
				codeInfo: {},
				peijianImage: '',
				bannerList: [],
				liangjiList: [],
				xianyuList: [],
				jingdongList: [],
				flawListOfB: [],
				flawListOfC: [],
				imageId: {}
			}
		},

		computed: {
			productName() {
				return [this.codeInfo.brand_name, this.codeInfo.spu_model_name, this.codeInfo.color_name, this.codeInfo.memory_name].filter(item => item).join(' ');
			}
		},

		mounted() {
			if (this.code) {
				this.codeHandle(this.code);
			}
		},
		
		methods: {
			codeHandle(code) {
				this.request({
					url: '/productCode/access/detail',
					data: {
						produce_unique_code: code
					},
					success: data => {
						this.codeInfo = data;

						this.request({
							url: '/quality/image/list',
							data: {
								product_code_id: data.id
							},
							success: data => {
								data.forEach(item => {
									this.imageId[item.image_url] = item.id;
								});
								this.peijianImage = data.find(item => item.image_type == 5) ? data.find(item => item.image_type == 5).image_url : '';
								this.bannerList = data.filter(item => item.image_type == 1).map(item => item.image_url);
								this.liangjiList = data.filter(item => item.image_type == 6).map(item => item.image_url);
								this.xianyuList = data.filter(item => item.image_type == 3).map(item => item.image_url);
								this.jingdongList = data.filter(item => item.image_type == 4).map(item => item.image_url);
								this.flawListOfB = data.filter(item => item.image_type == 2 && item.report_type == 1);
								this.flawListOfC = data.filter(item => item.image_type == 2 && item.report_type == 2);
							}
						});
					},
					fail: () => {
						this.$refs.scan.reset();
					}
				});
			},

			async uploadHandle(multiple, type, count) {
				if (type == 'peijianImage' && this.bannerList.length >= 13 && await this.$confirm({
					message: '轮播图已传满13张，上传配件图后将移除最后1张机器图，是否继续？'
				}) == 'cancel') {
					return;
				}
				this.$onShow(data => {
					if (data) {
						if (type == 'peijianImage') {
							this.peijianImage = data;
							if (this.bannerList.length >= 13) {
								this.bannerList.splice(12);
							}
						} else if (multiple) {
							this[type] = this[type].concat([data]);
						} else {
							type.image_url = data;
						}
					}
				}, true);
				this.mp.navigateTo('/pages/power/camera');
				// this.$upload({
				// 	count,
				// 	type: 'image',
				// 	loading: true,
				// 	success: data => {
				// 		if (type == 'peijianImage') {
				// 			this.peijianImage = data[0].path;
				// 			if (this.bannerList.length >= 13) {
				// 				this.bannerList.splice(12);
				// 			}
				// 		} else if (multiple) {
				// 			this[type] = this[type].concat(data.map(item => item.path));
				// 		} else {
				// 			type.image_url = data[0].path;
				// 		}
				// 	}
				// })
			},

			flawHandle(item) {
				this.$onShow(data => {
					if (data) {
						item.image_url = data;
					}
				}, true);
				this.mp.navigateTo('/pages/power/camera', {image: item.image_url});
			},

			submitHandle() {
				let image = [{
					id: this.imageId[this.peijianImage],
					image_url: this.peijianImage,
					image_type: 5,
					sort_id: 0
				}].concat(this.bannerList.map((item, index) => {
					return {
						id: this.imageId[item],
						image_url: item,
						image_type: 1,
						sort_id: index
					}
				})).concat(this.liangjiList.map((item, index) => {
					return {
						id: this.imageId[item],
						image_url: item,
						image_type: 6,
						sort_id: index
					}
				})).concat(this.xianyuList.map((item, index) => {
					return {
						id: this.imageId[item],
						image_url: item,
						image_type: 3,
						sort_id: index
					}
				})).concat(this.jingdongList.map((item, index) => {
					return {
						id: this.imageId[item],
						image_url: item,
						image_type: 4,
						sort_id: index
					}
				})).concat(this.flawListOfB.map(item => {
					return {
						release_id: item.release_id,
						release_parent_id: item.release_parent_id,
						quality_report_id: item.quality_report_id,
						image_url: item.image_url,
						image_type: 2
					}
				})).concat(this.flawListOfC.map(item => {
					return {
						release_id: item.release_id,
						release_parent_id: item.release_parent_id,
						quality_report_id: item.quality_report_id,
						image_url: item.image_url,
						image_type: 2
					}
				}));

				this.request({
					url: '/quality/image/upload',
					data: {
						product_code_id: this.codeInfo.id,
						images: image.length ? JSON.stringify(image) : ''
					},
					loading: true,
					success: () => {
						this.$message({
							message: '提交成功',
							mask: true
						});
						this.mp.navigateBack(true);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	>>> .head {
		padding: .26rem;
		margin-bottom: .2rem;
		font-size: .26rem;
		text-align: center;
		color: #666;
		background: #EFF2FF;

		h5 {
			margin-bottom: .2rem;
			font-size: .32rem;
			color: #000;
		}
	}

	.assets {
		margin: 0 .24rem .3rem;

		dt {
			gap: .1rem;
			height: 1.1rem;
			font-size: .3rem;
			color: var(--color-main);

			&:before, &:after {
				content: '';
				flex-grow: 1;
				width: 0;
				height: .02rem;
				background: #eee;
			}
		}

		dd {
			gap: .2rem;

			.tip {
				margin-bottom: .2rem;
				line-height: .36rem;
				font-size: .26rem;
				color: #666;
			}

			.list {
				gap: .2rem;
			}

			.image {
				position: relative;
				box-sizing: border-box;
				width: 1.6rem;
				height: 1.6rem;
				background: #F5F5F5;

				a {
					position: absolute;
					right: -.1rem;
					top: -.1rem;
					width: .36rem;
					height: .36rem;
					border: .04rem solid #fff;
					border-radius: 50%;
					line-height: .36rem;
					font-size: .2rem;
					text-align: center;
					color: #fff;
					background: #f55;
				}

				&-tag {
					position: absolute;
					left: 0;
					bottom: 0;
					width: .48rem;
					height: .48rem;
					border-top-right-radius: .12rem;
					padding: 0 .12rem;
					font-size: .24rem;
					color: #fff;
					background: rgba(0,0,0,.7);
				}

				&-edit {
					position: absolute;
					right: 0;
					bottom: 0;
					width: .48rem;
					height: .48rem;
					font-size: .24rem;
					color: #fff;
					background: rgba(0,0,0,.7);
				}

				&-text {
					width: 1.6rem;
					padding: .15rem 0;
					line-height: .34rem;
					font-size: .26rem;
					text-align: center;
					word-break: break-all;
					color: #666;
				}
			}

			.upload {
				gap: .1rem;
				box-sizing: border-box;
				width: 1.6rem;
				height: 1.6rem;
				border: 1px dashed #ddd;
				border-radius: .08rem;
				font-size: .4rem;
				color: #ccc;

				span {
					font-size: .28rem;
				}
			}
		}
	}
</style>